import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const validationSchema = (t: any) => {
  return yup.object().shape({
    empaSelection0: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .test("logical-validation", function (value, context) {
        const {
          empaSelection1,
          empaSelection2,
          empaSelection3,
          empaSelection4,
          empaSelection5,
          empaSelection6,
        } = context.parent;

        const otherSelections = [
          empaSelection1,
          empaSelection2,
          empaSelection3,
          empaSelection4,
          empaSelection5,
          empaSelection6,
        ];
        const hasYes = otherSelections.some((v) => v === "1");
        const hasNo = otherSelections.every((v) => v === "0");

        if (value === "0" && !hasNo) {
          return this.createError({
            path: "empaSelection0",
            message: t(
              "Αν επιλέξετε ότι δεν είστε υπόχρεος παραγωγός, πρέπει να απαντήσετε 'ΟΧΙ' σε όλες τις ερωτήσεις.",
            ),
          });
        }

        if (value === "1" && !hasYes) {
          return this.createError({
            path: "empaSelection0",
            message: t(
              "Αν επιλέξετε ότι είστε υπόχρεος παραγωγός, πρέπει να απαντήσετε 'ΝΑΙ' τουλάχιστον σε μία από τις ερωτήσεις.",
            ),
          });
        }

        return true;
      }),
    empaSelection1: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    empaSelection2: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    empaSelection3: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    empaSelection4: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    empaSelection5: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    empaSelection6: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
  });
};
